import { render } from "./AlertsWidget.vue?vue&type=template&id=b77974d8&scoped=true"
import script from "./AlertsWidget.vue?vue&type=script&lang=js"
export * from "./AlertsWidget.vue?vue&type=script&lang=js"

import "./AlertsWidget.vue?vue&type=style&index=0&id=b77974d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b77974d8"]])

export default __exports__